import { useFormContext, Controller } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { PrefixedInput } from '@components/Input';
import { useTranslation } from '@hooks';
import { SOCIAL_PLATFORMS, stripPrefix, resolveSocialLinkValue } from '@utils/socialLinkUtils';

const Form = styled('div')({
    maxWidth: 698,
    display: 'grid',
    columnGap: 24,
    rowGap: 16,
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
    '@media (max-width: 1024px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        maxWidth: 'none',
    },
});

export const SocialLinkField = ({ platform, control, isLocked = false, namePrefix = 'socialLinks', rules }) => {
    const { t } = useTranslation();
    const { key, label, display } = platform;

    return (
        <Controller
            control={control}
            name={`${namePrefix}.${key}`}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                const { suffix, matched } = stripPrefix(field.value || '', display);
                return (
                    <PrefixedInput
                        inputProps={{
                            ...field,
                            value: matched ? suffix : field.value || '',
                            onChange: e => field.onChange(resolveSocialLinkValue(e.target.value, platform)),
                        }}
                        prefix={matched ? display : null}
                        label={label}
                        fullWidth
                        disabled={isLocked}
                        error={!!error}
                        helperText={
                            isLocked ? t('SettingsCompanies.managedByConnection') : error ? t(error.message) : null
                        }
                    />
                );
            }}
        />
    );
};

const SocialLinks = ({ lockedSocialPlatforms = [], control: controlProp }) => {
    const formContext = useFormContext();
    const control = controlProp || formContext?.control;

    const lockedKeys = new Set((lockedSocialPlatforms || []).map(platform => platform.toLowerCase()));

    return (
        <Form>
            {SOCIAL_PLATFORMS.map(platform => (
                <SocialLinkField
                    key={platform.key}
                    platform={platform}
                    control={control}
                    isLocked={lockedKeys.has(platform.key.toLowerCase())}
                />
            ))}
        </Form>
    );
};

export default SocialLinks;
